import { memo, useEffect, useRef, useState } from 'react';
import './style.scss';
import { Divider, Row, Select, Space, Tag, Empty, Typography, Upload, Input, Button, message, Checkbox, Spin } from 'antd';
import stl from 'string-to-color';
// import { useListingCompanies } from '../../hooks/useCompanies';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { InboxOutlined, CloseCircleOutlined, EditOutlined, StopOutlined } from '@ant-design/icons';
import { useDownloadUpdatedCSV, useFetchCsvConfigList, useFetchCsvHeadersOnCompany, useSaveCsvConfig } from '../../hooks/useCsvOrder';
import AliasCard from './AliasCard';
import useLogout from '../../hooks/useLogout';
import axios from 'axios';
import SelectCompanyCode from '../../components/Planning/SelectCompany';
import stc from 'string-to-color';
import DynamicModal from '../../commonComponents/DynamicModal/DynamicModal';
import CommonTable from '../../commonComponents/Table/table';
import ExportExcel from '../../commonComponents/Export-Excel';
import { useProcessCsvData, getPresignedUrl, useSubmitSelectedData } from '../../hooks/useCsvOutboud';

const Outbounds = () => {
    const [companyCodeText, setCompanyCodeText] = useState('');
    const { logout } = useLogout();
    const [isUploadingCsv, setIsUploadingCsv] = useState(false);
    const [isDownloadingCsv, setIsDownloadingCsv] = useState(false);
    const [selectedFileKey, setSelectedKeyFile] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState('');
    const [selectedFileUrl, setSelectedFileUrl] = useState('');
    const [uploadedFileData, setUploadedFileData] = useState([]);
    const [checkedList, setCheckedList] = useState([]);

    const { mutate: submitSelectedData } = useSubmitSelectedData(onSuccessResultant, onResultErr);

    const manageCheckedList = data => {
        const ordersList = [...data];
        let checkedList = [];
        checkedList = ordersList
            ?.filter(item => (!!item?.orderName ? true : false))
            ?.map(item => {
                return item?.orderId;
            });
        setCheckedList(checkedList);
    };
    const onSuccessProcessCsv = data => {
        setUploadedFileData(data?.data?.data);
        manageCheckedList(data?.data?.data);
        setIsUploadingCsv(false);
    };

    const onErrorProcessCsv = err => {
        message.error(err?.response?.data?.message || 'Error!');
        setSelectedKeyFile(null);
        setSelectedFileName('');
        setSelectedFileUrl('');
        setIsUploadingCsv(false);
    };

    useProcessCsvData(selectedFileKey, companyCodeText, onSuccessProcessCsv, onErrorProcessCsv);

    const getcheckedStatus = oid => {
        let selectionList = [...checkedList];
        let oidIndex = selectionList?.findIndex(item => item === oid);
        if (oidIndex > -1) {
            return true;
        } else {
            return false;
        }
    };

    const handlecheckedStatus = (e, oid) => {
        let checked = e?.target?.checked;
        let selectionList = [...checkedList];

        if (checked) {
            selectionList.push(oid);
        } else {
            let oidIndex = selectionList?.findIndex(item => item === oid);
            let otherList = [...selectionList.slice(0, oidIndex), ...selectionList.slice(oidIndex + 1)];
            selectionList = [...otherList];
        }

        setCheckedList([...selectionList]);
    };

    function onSuccessResultant(response) {
        message.success(response?.data?.message || 'Successfull!');
        setSelectedFileUrl('');
        setUploadedFileData([]);
        setSelectedKeyFile(null);
        setSelectedFileName('');
        setCheckedList([]);
        setIsDownloadingCsv(false);
    }
    function onResultErr(err) {
        message.error(err?.response?.data?.message || 'Error');
        if (err?.response?.status === 401) logout();
        setIsDownloadingCsv(false);
    }

    const resetPage = () => {
        setCompanyCodeText('');
        setIsUploadingCsv(false);
        setIsDownloadingCsv(false);
        setSelectedKeyFile(null);
        setSelectedFileName('');
        setSelectedFileUrl('');
        setUploadedFileData([]);
        setCheckedList([]);
        // message.success('Updated successfully!');
    };

    const getHeader = () => {
        return (
            <div className="header_div">
                <Typography.Title level={4} style={{ margin: '0', padding: '0' }}>
                    {companyCodeText}{' '}
                    <Button
                        onClick={() => {
                            resetPage();
                        }}
                    >
                        <EditOutlined />
                    </Button>
                </Typography.Title>
            </div>
        );
    };

    const getConfigSelector = () => {
        return <div className="config_selector_div"></div>;
    };

    const getFileExtension = file => {
        var fileName = file.name;
        return fileName.split('.').pop();
    };

    const handleImageUpload = async file => {
        let reqDataObj = {};
        let fileName = file?.name;
        reqDataObj.mimeType = file.type;
        reqDataObj.fileExtension = getFileExtension(file);
        reqDataObj.fname = fileName || '';
        if (reqDataObj.fileExtension.toLowerCase() !== 'csv') {
            reqDataObj = {};
            message.error('Please upload only csv file.');
            setSelectedFileName('');
            return;
        }

        let params = {
            fname: reqDataObj.fname,
            companyCode: companyCodeText,
        };
        setIsUploadingCsv(true);
        getPresignedUrl(params)
            .then(resp => {
                axios.put(`${resp?.data?.url}`, file).then(async res => {
                    if (res?.status === 200) {
                        setSelectedKeyFile(resp?.data?.key);
                        setSelectedFileName(fileName);
                        setSelectedFileUrl(resp?.data?.url);
                        // One more Api to call
                        // setUploadedFileData({ name: 'Rishabh' });
                    } else {
                        throw new Error();
                    }
                });
            })
            .catch(err => {
                console.log(err);
                message.error(err?.response?.data?.message || 'Error');
                if (err?.response?.status === 401) {
                    logout();
                }
                setIsUploadingCsv(false);
            });
    };

    const getOrdersForApply = () => {
        let result = [];
        let selectionList = [...checkedList];
        let fileData = [...uploadedFileData];

        result = fileData
            .filter(item => selectionList.indexOf(item?.orderId) > -1)
            ?.map(item => {
                return {
                    orderId: item?.orderId,
                    orderName: item?.orderName,
                };
            });

        return result;
    };

    const handleSaveResource = async () => {
        let updatePayload = {
            key: selectedFileKey,
            companyCode: companyCodeText,
            orders: getOrdersForApply(),
        };
        setIsDownloadingCsv(true);
        submitSelectedData(updatePayload);
    };

    const props = {
        name: 'file',
        multiple: false,
        maxCount: '1',
        onChange: async info => {},
        onDrop: () => {},
        customRequest: async ({ file }) => {
            await handleImageUpload(file);
        },
        style: {
            height: '200px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            maxHeight: '30%',
        },
        showUploadList: false,
        accept: '.csv',
    };

    const getCsvSection = () => {
        return (
            <div className="csv_section">
                <Typography.Title level={5} style={{ margin: 0, padding: 0 }}>
                    Upload Csv
                </Typography.Title>

                {!!selectedFileName ? (
                    <div className="selected_file_area">
                        <span
                            style={{
                                padding: '4px',
                                color: '#B0A695',
                                border: '2px solid #EBE3D5',
                                borderRadius: '3px',
                                background: '#FFFBF5',
                                overflow: 'auto',
                                textWrap: 'wrap',
                            }}
                        >
                            {selectedFileName}
                        </span>
                        <span style={{ position: 'absolute', right: '7px', top: '3px' }}>
                            <Button
                                onClick={() => {
                                    setSelectedKeyFile(null);
                                    setSelectedFileName('');
                                    setSelectedFileUrl('');
                                    setUploadedFileData([]);
                                    setCheckedList([]);
                                }}
                                type="text"
                                style={{ margin: 0, padding: 0, height: 'fit-content', border: 'none' }}
                            >
                                <CloseCircleOutlined
                                    style={{
                                        color: '#B0A695',
                                        background: '#FFFBF5',
                                    }}
                                />
                            </Button>
                        </span>
                    </div>
                ) : (
                    <Upload.Dragger {...props}>
                        <>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">Click or drag file to this area to upload</p>
                            <p className="ant-upload-hint">Support for a single upload.</p>
                        </>
                    </Upload.Dragger>
                )}
            </div>
        );
    };

    const getExportDisabled = () => {
        let selectionList = [...checkedList];
        if (selectionList?.length === 0) {
            return true;
        } else {
            return false;
        }
    };

    const getUpdateButtonSection = () => {
        return (
            <div className="update_button_section">
                <Button
                    size="small"
                    onClick={handleSaveResource}
                    type="primary"
                    disabled={isUploadingCsv || isDownloadingCsv || getExportDisabled()}
                    loading={isUploadingCsv || isDownloadingCsv}
                >
                    Save
                </Button>
            </div>
        );
    };

    const getFileName = record => {
        return `Outbound_skus_download__${record?.skus?.length}_${new Date().toDateString()}_${new Date().toLocaleTimeString()}`;
    };

    const getExcelData = skus => {
        let items = [...skus];

        let exportedSkus = items?.map(sku => {
            return {
                ...sku,
                ['Outbound Timestamp']: sku?.['Outbound Timestamp']
                    ? new Date(sku?.['Outbound Timestamp'])?.toLocaleDateString('en-GB', {
                          day: 'numeric',
                          month: 'short',
                          year: 'numeric',
                      })
                    : '',
            };
        });

        return exportedSkus;
    };
    const columns = [
        {
            key: 'sNo',
            dataIndex: 'sNo',
            title: 'S No.',
            align: 'center',
            render: (_, record, index) => {
                return index + 1;
            },
        },
        {
            key: 'orderName',
            dataIndex: 'orderName',
            title: 'Order Name',
            align: 'center',
            render: (_, record) => {
                if (record?.orderName) {
                    return record?.orderName;
                } else {
                    return (
                        <span style={{ color: 'red', fontSize: '12px' }}>
                            {' '}
                            <span>Not found in any of the orders</span> <StopOutlined />
                        </span>
                    );
                }
            },
        },
        {
            key: 'skuCount',
            dataIndex: 'skuCount',
            title: 'SKU Counts',
            align: 'center',
            render: (_, record) => {
                return record?.skuCount;
            },
        },
        {
            key: 'selected',
            dataIndex: 'selected',
            title: 'Selected',
            align: 'center',
            render: (_, record) => {
                if (!record?.orderName) {
                    return <Checkbox checked={false} disabled={!record?.orderName} />;
                } else {
                    return (
                        <Checkbox
                            checked={getcheckedStatus(record?.orderId)}
                            disabled={!record?.orderName}
                            onChange={e => handlecheckedStatus(e, record?.orderId)}
                        />
                    );
                }
            },
        },
        {
            key: 'action',
            dataIndex: 'action',
            title: 'Action',
            align: 'center',
            render: (_, record) => {
                if (!record?.orderName) {
                    return (
                        <ExportExcel buttonSize="small" buttonText="Export" excelData={getExcelData(record?.skus)} fileName={getFileName(record)} />
                    );
                } else {
                    return '';
                }
            },
        },
    ];

    const getLeftTabularSection = () => {
        return <CommonTable columns={columns} data={uploadedFileData} customClass="main_table" loading={isUploadingCsv} />;
    };

    return (
        <>
            {!companyCodeText ? (
                <SelectCompanyCode onCompanyCodeSelected={setCompanyCodeText} isCsvTool={true} />
            ) : (
                <div className="tool_container">
                    {getHeader()}
                    <hr style={{ margin: '0', padding: '0' }} />
                    {getCsvSection()}
                    {getConfigSelector()}
                    <div className="table_container">
                        <div className="dragger_left_section">{getLeftTabularSection()}</div>
                        <div className="dragger_right_section"></div>
                    </div>

                    {getUpdateButtonSection()}
                </div>
            )}
        </>
    );
};

export default memo(Outbounds);
